import { Transition } from "@headlessui/react";
import { ChevronRightIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { ReactSVG } from "react-svg";

const CholesterolImportanceAlert = ({
  open = false,
  handleClose = () => {},
  confirmAction = () => {},
  onCross = () => {},
  className = "",
}) => {
  return (
    <Transition
      enter="transition duration-300 ease-out"
      enterFrom="transform scale-100 opacity-0"
      enterTo="transform scale-100 opacity-100"
      leave="transition duration-300 ease-out"
      leaveFrom="transform scale-300 opacity-100"
      leaveTo="transform scale-100 opacity-0"
      className={"fixed z-[11]  top-0 left-0 w-full h-screen"}
      show={open}
    >
      <div
        className="fixed inset-0 bg-black/10 z-[1]"
        onClick={() => handleClose()}
        aria-hidden="true"
      />
      <Transition.Child
        enter="transition duration-300 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-300 ease-out"
        leaveFrom="transform scale-300 opacity-100"
        leaveTo="transform scale-95 opacity-0"
        className={`bg-white z-[2] flex min-w-[717px] flex-col gap-6 absolute top-[55%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow-xl ${className} rounded-[40px]`}
      >
        <div className="flex flex-row w-full pt-2">
          <div className="px-4 pt-4 w-full flex items-center justify-center">
            <div className="absolute flex items-center justify-center mx-28 mb-4 h-[222px] w-[222px] border-green-150 border-[6px] rounded-full top-[-25%]">
              <div className="flex items-center justify-center h-[189px] w-[189px] bg-gray-50 rounded-full">
                <ReactSVG src={'/icons/cholesterol-medicines.svg'} className={`scale-[80%]`} />
              </div>
            </div>
            <button
              type="button"
              className="absolute flex items-center justify-center p-1 transition-all rounded-full max-w-8 cursor-pointer right-6 top-6 bg-teal-50 hover:bg-REELTeal hover:text-white text-teal-300"
              onClick={() => onCross()}
            >
              <span className="sr-only">Close panel</span>
              <XMarkIcon className="w-4 h-4" aria-hidden="true" />
            </button>
          </div>
        </div>
        <div className="px-8 pt-12">
          <div className="flex flex-col">
            <div className={`flex justify-center items-center flex-col gap-6`}>
              <h3 className="flex text-3xl font-semibold text-teal-300">Medications can LOWER RISK for:</h3>
              <div className="flex flex-col text-lg font-normal gap-6 bg-gray-20 border-green-150 border-[6px] rounded-[20px] py-8 px-12 items-center">
                <div className="flex flex-col gap-4 w-[390px] items-center justify-center">
                  <div className="flex items-center relative w-[235px] h-[53px] mt-0 rounded-[10px] px-[10px] py-[6px] gap-[10px] bg-gray-100">
                    <span className="flex w-[10px] h-[10px] rounded-full bg-teal-300"></span>
                    <div className="flex items-center justify-center absolute w-[215px] h-[53px] top-[-8px] left-[36px] rounded-[10px] px-[10px] py-[6px] gap-[10px] bg-white text-teal-300 font-bold text-2xl">Stroke</div>
                  </div>

                  <div className="flex items-center relative w-[235px] h-[53px] rounded-[10px] px-[10px] py-[6px] gap-[10px] bg-gray-100">
                    <span className="flex w-[10px] h-[10px] rounded-full bg-teal-300"></span>
                    <div className="flex items-center justify-center absolute w-[215px] h-[53px] top-[-8px] left-[36px] rounded-[10px] px-[10px] py-[6px] gap-[10px] bg-white text-teal-300 font-bold text-2xl">Heart Attack</div>
                  </div>

                  <div className="flex items-center relative w-[235px] h-[53px] rounded-[10px] px-[10px] py-[6px] gap-[10px] bg-gray-100">
                    <span className="flex w-[10px] h-[10px] rounded-full bg-teal-300"></span>
                    <div className="flex items-center justify-center absolute w-[215px] h-[53px] top-[-8px] left-[36px] rounded-[10px] px-[10px] py-[6px] gap-[10px] bg-white text-teal-300 font-bold text-2xl">Heart Disease</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <button
            className={`float-right m-2 mb-6 h-[38px] w-auto rounded-full bg-REELTeal border-REELTeal hover:bg-teal-200 inline-flex border transition-all duration-300 items-center font-semibold justify-center px-3 py-4`}
            onClick={() => confirmAction()}
          >
            <h3 className="text-body-md font-semibold text-white">Go to Lifestyle</h3>
            <ChevronRightIcon className="w-4 ml-2 h-4 text-white" />
          </button>
        </div>
      </Transition.Child>
    </Transition>
  );
};

export default CholesterolImportanceAlert;
